/*
 * All You Can Play - menu dei giochi da computer (snippets/aycp-menu-giochi.liquid, assets/aycp-menu-giochi.css).
 * Attivo solo da 990 px in su; sotto non fa niente e telefono e tablet restano come prima.
 * - Passando su un logo della banda si apre il pannello del gioco: Tipologia, Set dal più recente,
 *   Tutti i prodotti, In evidenza. Cliccando sul logo si apre la collezione del gioco.
 * - Passando su "TCGs" (o cliccandoci) si apre il pannello con la colonna dei giochi al posto della tendina di Dawn.
 * - Lo stesso per "Giochi da tavolo" (colonna con i loghi dei giochi e i prodotti del gioco su cui si passa) e per
 *   "Altri prodotti" (tipologie e prodotti disponibili degli accessori, buono regalo): i prodotti arrivano da
 *   sections/aycp-menu-prodotti.liquid quando il mouse entra nella voce, senza pre-caricamento.
 * - Il contenuto di un gioco arriva da sections/aycp-menu-pannello.liquid e resta per 15 minuti nella visita
 *   (sessionStorage), così non si richiede a ogni pagina. Si pre-carica: dopo il caricamento della pagina,
 *   quando il browser è libero, si chiedono i dati dei giochi uno alla volta e si scaricano, con priorità bassa,
 *   le immagini che si vedono all'apertura dei pannelli (le prime 8 copertine e In evidenza). Non parte con il
 *   risparmio dati o una connessione lentissima; in quei casi si carica tutto al passaggio sul logo.
 * - Copertine e immagini in due misure (240 e 480 px): gli schermi normali scaricano la 240, quelli ad alta
 *   risoluzione la 480.
 * - Passando da una voce all'altra (o da un logo all'altro della banda) il pannello nuovo compare subito al posto
 *   di quello di prima, che resta sopra per un attimo e sfuma: lo schermo non resta mai vuoto. L'entrata
 *   (dissolvenza dall'alto) c'è solo quando non c'era nessun pannello aperto.
 * - Le fasce vuote a destra e a sinistra del riquadro bianco fanno parte del pannello: lì non si chiude da solo e
 *   un clic lo chiude subito, senza arrivare alla pagina sotto.
 * - Scorrendo, quando la parte alta della pagina esce dallo schermo, la testata scende con un rimbalzo:
 *   menu con il logo di 40 px, ricerca più bassa, banda intera. Tornando su torna normale.
 * Sui computer senza mouse (schermi touch) i loghi portano direttamente alla collezione.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-aycp-mg]');
  if (!root || root.hasAttribute('data-aycp-ready')) return;
  root.setAttribute('data-aycp-ready', '');

  var html = document.documentElement;
  var wrap = root.closest('.header-wrapper') || root.parentElement;
  var section = root.closest('.section-header') || wrap;
  var desktop = window.matchMedia('(min-width: 990px)');
  var hover = window.matchMedia('(hover: hover)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  var cfg = null;
  try {
    var dataEl = root.querySelector('[data-aycp-mg-data]');
    if (dataEl) cfg = JSON.parse(dataEl.textContent);
  } catch (e) {
    cfg = null;
  }
  var games = cfg && cfg.games ? cfg.games : [];
  var S = cfg && cfg.s ? cfg.s : {};

  var bandPanel = root.querySelector('[data-aycp-band-panel]');
  var tcgsPanel = root.querySelector('[data-aycp-tcgs-panel]');
  var tcgsBody = root.querySelector('[data-aycp-tcgs-body]');
  var cells = Array.prototype.slice.call(root.querySelectorAll('.aycp-mg__cell'));
  var railItems = Array.prototype.slice.call(root.querySelectorAll('.aycp-mg__rail-game'));
  var summary = root.getAttribute('data-tcgs') ? document.getElementById(root.getAttribute('data-tcgs')) : null;
  var details = summary ? summary.closest('details') : null;

  var active = false;

  /* ---------- dati di un gioco ---------- */
  var TTL = 15 * 60 * 1000;
  var themeId = window.Shopify && window.Shopify.theme && window.Shopify.theme.id ? window.Shopify.theme.id : '';
  var storeKey = 'aycp-mg-v1:' + themeId + ':' + (cfg ? cfg.root : '') + ':';
  var memory = {};
  var loaded = {};

  function load(i) {
    var g = games[i];
    if (!g) return Promise.reject(new Error('gioco'));
    if (memory[g.h]) return memory[g.h];
    try {
      var raw = window.sessionStorage.getItem(storeKey + g.h);
      if (raw) {
        var saved = JSON.parse(raw);
        if (saved && saved.d && Date.now() - saved.at < TTL) {
          loaded[g.h] = saved.d;
          memory[g.h] = Promise.resolve(saved.d);
          return memory[g.h];
        }
      }
    } catch (e) {
      /* senza sessionStorage si richiede ogni volta */
    }
    var url = g.u + (g.u.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(cfg.section);
    memory[g.h] = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var script = doc.querySelector('[data-aycp-panel]');
        var d = script ? JSON.parse(script.textContent) : null;
        if (!d || !d.sets) throw new Error('vuoto');
        loaded[g.h] = d;
        try {
          window.sessionStorage.setItem(storeKey + g.h, JSON.stringify({ at: Date.now(), d: d }));
        } catch (e) {
          /* spazio pieno o non disponibile: va bene lo stesso */
        }
        return d;
      });
    memory[g.h].catch(function () {
      delete memory[g.h];
    });
    return memory[g.h];
  }

  /* ---------- immagini in due misure ---------- */
  // la miniatura di un set è larga circa 184 px, l'immagine di In evidenza circa 212: con 240 e 480 px
  // gli schermi normali prendono la 240 e quelli ad alta risoluzione la 480 (gli indirizzi di Shopify hanno width=)
  var TILE_SIZES = '190px';
  var FEAT_SIZES = '240px';

  function variant(url, w) {
    return url.replace(/([?&]width=)\d+/, '$1' + w);
  }

  function srcsetOf(url) {
    return /[?&]width=\d+/.test(url) ? variant(url, 240) + ' 240w, ' + variant(url, 480) + ' 480w' : '';
  }

  function imgTag(url, sizes) {
    var set = srcsetOf(url);
    return (
      '<img src="' + esc(set ? variant(url, 480) : url) + '"' +
      (set ? ' srcset="' + esc(set) + '" sizes="' + sizes + '"' : '') +
      ' alt="" decoding="async">'
    );
  }

  // scarica in anticipo, con priorità bassa, le immagini che si vedono all'apertura del pannello di un gioco
  // (le prime 8 copertine e In evidenza), nella stessa misura che sceglierà il pannello
  var warmed = {};

  function warm(i) {
    var g = games[i];
    var d = g ? loaded[g.h] : null;
    if (!d || warmed[g.h]) return;
    warmed[g.h] = true;
    var list = [];
    d.sets.slice(0, 8).forEach(function (s) {
      if (s.i) list.push([s.i, TILE_SIZES]);
    });
    if (d.feat && d.feat.i) list.push([d.feat.i, FEAT_SIZES]);
    list.forEach(function (item) {
      var img = new Image();
      img.decoding = 'async';
      if ('fetchPriority' in img) img.fetchPriority = 'low';
      var set = srcsetOf(item[0]);
      if (set) {
        img.sizes = item[1];
        img.srcset = set;
        img.src = variant(item[0], 480);
      } else {
        img.src = item[0];
      }
    });
  }

  /* ---------- pezzi dei pannelli ---------- */
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function badge() {
    return '<span class="aycp-mg__badge">' + esc(S.pre) + '</span>';
  }

  // "Esaurito" sulle miniature dei set: la stessa etichetta delle schede prodotto (badge di Dawn con lo schema
  // colori dell'impostazione del tema per l'etichetta esaurito), in alto a destra come "Preordine"
  function soldOutBadge() {
    return '<span class="badge aycp-mg__soldout ' + esc(S.soldOutClass || '') + '">' + esc(S.soldOut || S.out) + '</span>';
  }

  function typesOf(g, d) {
    return g.types
      .map(function (t) {
        return { l: t.l, u: t.u, n: d && d.tags ? d.tags[t.g] || 0 : null };
      })
      .filter(function (t) {
        return t.n === null || t.n > 0;
      });
  }

  function count(n) {
    return n === null ? '' : '<span class="aycp-mg__n">' + n + '</span>';
  }

  function chip(t) {
    return '<a class="aycp-mg__chip" href="' + esc(t.u) + '">' + esc(t.l) + count(t.n) + '</a>';
  }

  function typeRow(t) {
    return '<a class="aycp-mg__row" href="' + esc(t.u) + '"><span class="aycp-mg__row-t">' + esc(t.l) + '</span>' + count(t.n) + '</a>';
  }

  function setLabel(s) {
    return (s.c ? s.c + ' ' : '') + s.t;
  }

  function tile(s) {
    var out = !s.b;
    var inner;
    if (s.i) {
      inner = imgTag(s.i, TILE_SIZES);
    } else {
      inner =
        '<span class="aycp-mg__tile-txt">' +
        (s.c ? '<span class="aycp-mg__tile-code">' + esc(s.c) + '</span>' : '') +
        '<span class="aycp-mg__tile-name">' + esc(s.t) + '</span></span>';
    }
    return (
      '<a class="aycp-mg__tile' + (s.i ? '' : ' aycp-mg__tile--plain') + (out ? ' is-out' : '') + '" href="' + esc(s.u) + '"' +
      (s.i ? ' aria-label="' + esc(setLabel(s) + (out ? ', ' + S.out : '')) + '" title="' + esc(setLabel(s)) + '"' : '') + '>' +
      inner +
      (s.p ? badge() : out ? soldOutBadge() : '') +
      '</a>'
    );
  }

  function srow(s) {
    return (
      '<a class="aycp-mg__srow' + (s.c ? '' : ' aycp-mg__srow--nocode') + (s.b ? '' : ' is-out') + '" href="' + esc(s.u) + '">' +
      (s.c ? '<span class="aycp-mg__code">' + esc(s.c) + '</span>' : '') +
      '<span class="aycp-mg__srow-t">' + esc(s.t) + (s.p ? badge() : '') +
      (s.b ? '' : '<span class="aycp-mg__srow-out">' + esc(S.out) + '</span>') +
      '</span></a>'
    );
  }

  function prodCard(p) {
    return (
      '<a class="aycp-mg__prod" href="' + esc(p.u) + '">' +
      '<span class="aycp-mg__prod-img">' + (p.i ? imgTag(p.i, FEAT_SIZES) : '') + '</span>' +
      '<span class="aycp-mg__prod-t">' + esc(p.t) + '</span>' +
      '<span class="aycp-mg__prod-p">' + esc(p.pr) + '</span>' +
      '<span class="aycp-mg__prod-n">' + esc(p.no) + '</span>' +
      '</a>'
    );
  }

  function more(sets, all) {
    return !all && sets.length > 8
      ? '<button class="aycp-mg__more" type="button" data-aycp-more>' + esc(String(S.showAllSets).replace('[n]', sets.length)) + '</button>'
      : '';
  }

  function message(g) {
    return '<p class="aycp-mg__msg">' + esc(loaded[g.h] === undefined && memory[g.h] ? S.loading : S.error) + '</p>';
  }

  /* pannello della banda */
  function gamePanelHtml(i, all) {
    var g = games[i];
    var d = loaded[g.h] || null;
    var types = typesOf(g, d);
    var sets = d ? d.sets : [];
    var shown = all ? sets : sets.slice(0, 8);
    var n = d ? d.n : g.n;
    var main = '';
    if (types.length) {
      main += '<div class="aycp-mg__h">' + esc(S.types) + '</div><div class="aycp-mg__chips">' + types.map(chip).join('') + '</div>';
    }
    if (!d) main += message(g);
    if (sets.length) {
      main +=
        '<div class="aycp-mg__h">' + esc(S.sets) + '</div>' +
        '<div class="aycp-mg__tiles' + (all ? ' is-all' : '') + '">' + shown.map(tile).join('') + '</div>';
    }
    main +=
      '<div class="aycp-mg__foot">' + (more(sets, all) || '<span></span>') +
      '<a class="aycp-mg__all" href="' + esc(g.u) + '">' + esc(S.allProducts) + ' (' + n + ')</a></div>';
    var side = d && d.feat ? '<div class="aycp-mg__gp-side"><div class="aycp-mg__h">' + esc(S.feat) + '</div>' + prodCard(d.feat) + '</div>' : '';
    return (
      '<div class="aycp-mg__panel-in"><div class="aycp-mg__gp' + (side ? '' : ' aycp-mg__gp--nofeat') + '">' +
      '<div class="aycp-mg__gp-main">' + main + '</div>' + side + '</div></div>'
    );
  }

  /* parte destra del pannello di TCGs */
  function tcgsBodyHtml(i, all) {
    var g = games[i];
    var d = loaded[g.h] || null;
    var types = typesOf(g, d);
    var sets = d ? d.sets : [];
    var shown = all ? sets : sets.slice(0, 8);
    var n = d ? d.n : g.n;
    var logo = g.logo
      ? '<img src="' + esc(g.logo) + '" alt="' + esc(g.t) + '">'
      : '<span class="aycp-mg__logo-name">' + esc(g.t) + '</span>';
    return (
      '<div class="aycp-mg__top"><h3 class="aycp-mg__title"><span class="aycp-mg__logo">' + logo + '</span></h3>' +
      '<a class="aycp-mg__all" href="' + esc(g.u) + '">' + esc(S.viewAll) + ' (' + n + ')</a></div>' +
      '<div class="aycp-mg__cols">' +
      '<div>' + (types.length ? '<div class="aycp-mg__h">' + esc(S.types) + '</div>' + types.map(typeRow).join('') : '') + '</div>' +
      '<div>' +
      (d
        ? sets.length
          ? '<div class="aycp-mg__h">' + esc(S.sets) + '</div><div class="aycp-mg__srows' + (all ? ' is-all' : '') + '">' + shown.map(srow).join('') + '</div>' + more(sets, all)
          : ''
        : message(g)) +
      '</div>' +
      '<div>' + (d && d.feat ? '<div class="aycp-mg__h">' + esc(S.feat) + '</div>' + prodCard(d.feat) : '') + '</div>' +
      '</div>'
    );
  }

  /* ---------- Giochi da tavolo e Altri prodotti: pannelli con i prodotti ---------- */
  // le voci del menu "Board Games" e "Other Products" (dati in snippets/aycp-menu-giochi.liquid); i prodotti arrivano
  // da sections/aycp-menu-prodotti.liquid quando il mouse entra nella voce (niente pre-caricamento) e restano
  // 15 minuti nella visita, come i dati dei giochi
  var BG_SIZES = '150px';
  var OP_SIZES = '190px';
  var extras = (cfg && cfg.x ? cfg.x : []).filter(function (x) {
    x.summary = document.getElementById(x.id);
    x.details = x.summary ? x.summary.closest('details') : null;
    x.panel = root.querySelector('[data-aycp-x="' + x.id + '"]');
    x.sel = 0;
    x.timer = null;
    x.built = false;
    x.down = -1;
    return !!(x.summary && x.panel && (x.k !== 'bg' || (x.games && x.games.length)));
  });
  var prodMemory = {};
  var prodLoaded = {};

  function norm(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function loadProds(h, u) {
    if (prodMemory[h]) return prodMemory[h];
    var key = storeKey + 'p:' + h;
    try {
      var raw = window.sessionStorage.getItem(key);
      if (raw) {
        var saved = JSON.parse(raw);
        if (saved && saved.d && Date.now() - saved.at < TTL) {
          prodLoaded[h] = saved.d;
          prodMemory[h] = Promise.resolve(saved.d);
          return prodMemory[h];
        }
      }
    } catch (e) {
      /* senza sessionStorage si richiede ogni volta */
    }
    var url = u + (u.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(cfg.xsection);
    prodMemory[h] = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var script = doc.querySelector('[data-aycp-prods]');
        var d = script ? JSON.parse(script.textContent) : null;
        if (!d || !d.p) throw new Error('vuoto');
        d.p.forEach(function (p) {
          p.g = (p.g || []).map(norm);
        });
        prodLoaded[h] = d;
        try {
          window.sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), d: d }));
        } catch (e) {
          /* spazio pieno o non disponibile: va bene lo stesso */
        }
        return d;
      });
    prodMemory[h].catch(function () {
      delete prodMemory[h];
    });
    return prodMemory[h];
  }

  function sourcesOf(x) {
    if (x.k === 'bg') return [{ h: x.h, u: x.u }];
    return (x.cols || [])
      .filter(function (c) {
        return c.k === 'c';
      })
      .map(function (c) {
        return { h: c.h, u: c.u };
      });
  }

  function loadExtra(x) {
    return Promise.all(
      sourcesOf(x).map(function (s) {
        return loadProds(s.h, s.u);
      })
    );
  }

  function extraReady(x) {
    return sourcesOf(x).every(function (s) {
      return !!prodLoaded[s.h];
    });
  }

  function waiting(h) {
    return '<p class="aycp-mg__msg">' + esc(prodMemory[h] ? S.loading : S.error) + '</p>';
  }

  // prima i prodotti che si possono comprare, poi dal prezzo più alto
  function byAvailability(list) {
    return list.slice().sort(function (a, b) {
      return (b.b ? 1 : 0) - (a.b ? 1 : 0) || (b.v || 0) - (a.v || 0);
    });
  }

  function withTag(list, tag) {
    return list.filter(function (p) {
      return p.g.indexOf(tag) !== -1;
    });
  }

  // nel pannello dei giochi da tavolo il titolo perde l'editore ("Asmodee - 7 Wonders ..."): il gioco è già scritto
  // in alto; nella pagina del prodotto e per Google il titolo resta intero
  function withoutPublisher(t) {
    var i = t.indexOf(' - ');
    return i > 0 && i <= 30 ? t.slice(i + 3) : t;
  }

  function pcard(p, sizes, strip) {
    return (
      '<a class="aycp-mg__pcard" href="' + esc(p.u) + '">' +
      '<span class="aycp-mg__pcard-img">' + (p.i ? imgTag(p.i, sizes) : '') + (p.b === false ? soldOutBadge() : '') + '</span>' +
      '<span class="aycp-mg__pcard-t">' + esc(strip ? withoutPublisher(p.t) : p.t) + '</span>' +
      '<span class="aycp-mg__pcard-p">' + esc(p.pr) + '</span>' +
      '</a>'
    );
  }

  function nProducts(n) {
    return n + ' ' + (n === 1 ? S.product1 : S.productN);
  }

  function gameLogo(g) {
    return g.logo
      ? '<img src="' + esc(g.logo) + '" alt="' + esc(g.l) + '"' + (g.s && g.s !== 100 ? ' style="transform: scale(' + g.s / 100 + ')"' : '') + '>'
      : '<span class="aycp-mg__logo-name">' + esc(g.l) + '</span>';
  }

  /* Giochi da tavolo: colonna dei giochi + prodotti del gioco scelto */
  function bgBodyHtml(x) {
    var g = x.games[x.sel];
    var d = prodLoaded[x.h] || null;
    var list = d ? byAvailability(withTag(d.p, g.g)) : [];
    return (
      '<div class="aycp-mg__top"><h3 class="aycp-mg__title"><span class="aycp-mg__logo">' + gameLogo(g) + '</span></h3>' +
      (d ? '<a class="aycp-mg__all" href="' + esc(g.u) + '">' + esc(S.viewAll) + ' (' + list.length + ')</a>' : '') +
      '</div>' +
      (d
        ? '<div class="aycp-mg__pgrid aycp-mg__pgrid--5">' +
          list
            .slice(0, 10)
            .map(function (p) {
              return pcard(p, BG_SIZES, true);
            })
            .join('') +
          '</div>'
        : waiting(x.h))
    );
  }

  function bgCounts(x) {
    var d = prodLoaded[x.h] || null;
    Array.prototype.forEach.call(x.panel.querySelectorAll('.aycp-mg__rail-game'), function (item, k) {
      var n = item.querySelector('.aycp-mg__n');
      if (n) n.textContent = d ? nProducts(withTag(d.p, x.games[k].g).length) : '';
    });
    var all = x.panel.querySelector('[data-aycp-x-all]');
    if (all) all.textContent = S.allBoardGames + ' (' + (d ? d.n : x.n) + ')';
  }

  function bgSelect(x, k, focus) {
    x.sel = k;
    Array.prototype.forEach.call(x.panel.querySelectorAll('.aycp-mg__rail-game'), function (item, j) {
      item.setAttribute('aria-selected', String(j === k));
      item.setAttribute('tabindex', j === k ? '0' : '-1');
      if (focus && j === k) item.focus();
    });
    var body = x.panel.querySelector('.aycp-mg__tcgs-body');
    if (body) body.innerHTML = bgBodyHtml(x);
  }

  function bgBuild(x) {
    x.panel.innerHTML =
      '<div class="aycp-mg__panel-in"><div class="aycp-mg__tcgs-in">' +
      '<div class="aycp-mg__rail" role="tablist" aria-label="' + esc(x.t) + '">' +
      '<div class="aycp-mg__h aycp-mg__rail-h">' + esc(x.t) + '</div>' +
      x.games
        .map(function (g, k) {
          return (
            '<div class="aycp-mg__rail-game" role="tab" tabindex="' + (k === x.sel ? '0' : '-1') + '" aria-selected="' + (k === x.sel) + '" data-aycp-k="' + k + '">' +
            '<span class="aycp-mg__logo">' + gameLogo(g) + '</span><span class="aycp-mg__n"></span></div>'
          );
        })
        .join('') +
      '<a class="aycp-mg__all aycp-mg__rail-all" href="' + esc(x.u) + '" data-aycp-x-all></a>' +
      '</div><div class="aycp-mg__tcgs-body" role="tabpanel"></div></div></div>';
    x.built = true;
    function itemOf(event) {
      var item = event.target.closest('.aycp-mg__rail-game');
      return item ? Number(item.getAttribute('data-aycp-k')) : -1;
    }
    // come nel pannello di TCGs: con il mouse il gioco si sceglie passandoci sopra e il clic apre i suoi prodotti;
    // sugli schermi touch il primo tocco lo sceglie, il secondo apre
    x.panel.addEventListener('mouseover', function (event) {
      var k = itemOf(event);
      if (k >= 0 && hover.matches && k !== x.sel) bgSelect(x, k, false);
    });
    x.panel.addEventListener('focusin', function (event) {
      var k = itemOf(event);
      if (k >= 0 && k !== x.sel) bgSelect(x, k, false);
    });
    x.panel.addEventListener('pointerdown', function (event) {
      var k = itemOf(event);
      x.down = k >= 0 && k === x.sel ? k : -1;
    });
    x.panel.addEventListener('click', function (event) {
      var k = itemOf(event);
      if (k < 0) return;
      if (hover.matches || x.down === k) {
        window.location.href = x.games[k].u;
      } else {
        bgSelect(x, k, false);
      }
      x.down = -1;
    });
    x.panel.addEventListener('keydown', function (event) {
      var k = itemOf(event);
      if (k < 0) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        window.location.href = x.games[k].u;
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        bgSelect(x, (k + (event.key === 'ArrowDown' ? 1 : -1) + x.games.length) % x.games.length, true);
      }
    });
  }

  /* Altri prodotti: a sinistra le collezioni (tipologie e prodotti disponibili), a destra i prodotti della voce */
  function opHtml(x) {
    var left = '';
    var right = '';
    (x.cols || []).forEach(function (c) {
      if (c.k === 'c') {
        var d = prodLoaded[c.h] || null;
        var chips = [{ l: S.allProducts, u: c.u, n: d ? d.n : c.n }]
          .concat(
            (c.types || []).map(function (t) {
              return { l: t.l, u: t.u, n: d ? withTag(d.p, t.g).length : null };
            })
          )
          .filter(function (t) {
            return t.n === null || t.n > 0;
          });
        left += '<div class="aycp-mg__h">' + esc(c.l) + '</div><div class="aycp-mg__chips">' + chips.map(chip).join('') + '</div>';
        if (d) {
          var shown = byAvailability(
            d.p.filter(function (p) {
              return p.b;
            })
          ).slice(0, 4);
          if (shown.length) {
            left +=
              '<div class="aycp-mg__h">' + esc(S.available) + '</div><div class="aycp-mg__pgrid">' +
              shown
                .map(function (p) {
                  return pcard(p, OP_SIZES, false);
                })
                .join('') +
              '</div>';
          }
        } else {
          left += waiting(c.h);
        }
      } else if (c.k === 'p') {
        right += '<div class="aycp-mg__h">' + esc(c.l) + '</div>' + prodCard({ u: c.u, i: c.i, t: c.t, pr: c.pr, no: '' });
      }
    });
    return (
      '<div class="aycp-mg__panel-in"><div class="aycp-mg__gp' + (right ? '' : ' aycp-mg__gp--nofeat') + '">' +
      '<div class="aycp-mg__gp-main">' + left + '</div>' + (right ? '<div class="aycp-mg__gp-side">' + right + '</div>' : '') +
      '</div></div>'
    );
  }

  function renderExtra(x) {
    // ridisegnato mentre è aperto (per esempio quando arrivano i prodotti): senza rifare l'entrata
    if (x.panel.classList.contains('is-open')) x.panel.classList.add('is-still');
    if (x.k === 'bg') {
      if (!x.built) bgBuild(x);
      bgCounts(x);
      var body = x.panel.querySelector('.aycp-mg__tcgs-body');
      if (body) body.innerHTML = bgBodyHtml(x);
    } else {
      x.panel.innerHTML = opHtml(x);
    }
  }

  function openExtra(x, focusRail) {
    // già aperto: non si ridisegna (tornando sulla voce dal pannello non deve lampeggiare)
    if (x.panel.classList.contains('is-open')) {
      if (focusRail && x.k === 'bg') bgSelect(x, x.sel, true);
      return;
    }
    var prev = openPanel();
    ghostOf(prev);
    closeBand();
    closeTcgs();
    closeExtras(x);
    if (x.details) x.details.removeAttribute('open');
    x.panel.classList.toggle('is-still', !!prev);
    renderExtra(x);
    x.panel.classList.add('is-open');
    x.summary.setAttribute('aria-expanded', 'true');
    if (focusRail && x.k === 'bg') bgSelect(x, x.sel, true);
    if (!extraReady(x)) {
      var again = function () {
        if (x.panel.classList.contains('is-open')) renderExtra(x);
      };
      loadExtra(x).then(again, again);
    }
  }

  function closeExtra(x) {
    clearTimeout(x.timer);
    x.panel.classList.remove('is-open');
    x.summary.setAttribute('aria-expanded', 'false');
  }

  function closeExtras(except) {
    extras.forEach(function (x) {
      if (x !== except) closeExtra(x);
    });
  }

  extras.forEach(function (x) {
    x.summary.addEventListener('mouseenter', function () {
      if (!active || !hover.matches) return;
      loadExtra(x).catch(function () {});
      holdOpen();
      clearTimeout(x.timer);
      x.timer = setTimeout(function () {
        openExtra(x, false);
      }, 110);
    });
    x.summary.addEventListener('mouseleave', function () {
      if (!active || !hover.matches) return;
      clearTimeout(x.timer);
      x.timer = setTimeout(function () {
        closeExtra(x);
      }, 260);
      releaseOpen(x.panel);
    });
    x.summary.addEventListener('click', function (event) {
      if (!active) return;
      event.preventDefault();
      clearTimeout(x.timer);
      var open = x.panel.classList.contains('is-open');
      if (open && event.detail !== 0 && hover.matches) return;
      if (open) {
        closeExtra(x);
      } else {
        openExtra(x, event.detail === 0);
      }
    });
    x.panel.addEventListener('mouseenter', function () {
      clearTimeout(x.timer);
    });
    x.panel.addEventListener('mouseleave', function () {
      if (!hover.matches) return;
      clearTimeout(x.timer);
      x.timer = setTimeout(function () {
        closeExtra(x);
      }, 260);
    });
  });

  /* ---------- aprire e chiudere ---------- */
  var bandTimer = null;
  var tcgsTimer = null;
  var bandGame = -1;
  var tcgsGame = 0;
  var railDown = -1;

  /* ---------- passare da un menu all'altro senza lampi ---------- */
  // il pannello aperto in questo momento (al massimo uno)
  function openPanel() {
    var list = [bandPanel, tcgsPanel].concat(
      extras.map(function (x) {
        return x.panel;
      })
    );
    for (var k = 0; k < list.length; k++) {
      if (list[k] && list[k].classList.contains('is-open')) return list[k];
    }
    return null;
  }

  // Al posto del pannello che si chiude resta per un attimo una sua copia, sopra quello nuovo, che sfuma.
  // La copia non si può toccare né raggiungere con la tastiera e sparisce alla fine della dissolvenza.
  function ghostOf(panel) {
    if (!panel || !panel.parentNode || reduced.matches || !panel.animate) return;
    var g = panel.cloneNode(true);
    ['id', 'data-aycp-band-panel', 'data-aycp-tcgs-panel', 'data-aycp-x'].forEach(function (a) {
      g.removeAttribute(a);
    });
    Array.prototype.forEach.call(g.querySelectorAll('[id], [data-aycp-tcgs-body]'), function (el) {
      el.removeAttribute('id');
      el.removeAttribute('data-aycp-tcgs-body');
    });
    // le immagini sono già scaricate: così si vedono subito anche nella copia
    Array.prototype.forEach.call(g.querySelectorAll('img'), function (img) {
      img.removeAttribute('loading');
      img.setAttribute('decoding', 'sync');
    });
    g.classList.add('aycp-mg__ghost', 'is-still');
    g.setAttribute('aria-hidden', 'true');
    g.inert = true;
    panel.parentNode.insertBefore(g, panel.nextSibling);
    var from = panel.querySelector('.aycp-mg__panel-in');
    var to = g.querySelector('.aycp-mg__panel-in');
    if (from && to && from.scrollTop) to.scrollTop = from.scrollTop;
    var done = function () {
      if (g.parentNode) g.parentNode.removeChild(g);
    };
    var a = g.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, easing: 'ease-in' });
    a.onfinish = done;
    a.oncancel = done;
  }

  // Il mouse entra in un'altra voce del menu: il pannello aperto non si chiude da solo, lo sostituirà quello
  // nuovo. Se poi esce dalla voce senza aprirla, il pannello rimasto aperto si chiude come prima.
  function holdOpen() {
    clearTimeout(bandTimer);
    clearTimeout(tcgsTimer);
    extras.forEach(function (x) {
      clearTimeout(x.timer);
    });
  }

  function releaseOpen(own) {
    if (bandPanel && bandPanel !== own && bandPanel.classList.contains('is-open')) {
      clearTimeout(bandTimer);
      bandTimer = setTimeout(closeBand, 180);
    }
    if (tcgsPanel && tcgsPanel !== own && tcgsPanel.classList.contains('is-open')) {
      clearTimeout(tcgsTimer);
      tcgsTimer = setTimeout(closeTcgs, 260);
    }
    extras.forEach(function (x) {
      if (x.panel === own || !x.panel.classList.contains('is-open')) return;
      clearTimeout(x.timer);
      x.timer = setTimeout(function () {
        closeExtra(x);
      }, 260);
    });
  }

  function renderBand(all) {
    if (bandGame < 0) return;
    // ridisegnato mentre è aperto (altro logo, dati arrivati, "mostra tutti"): senza rifare l'entrata
    if (bandPanel.classList.contains('is-open')) bandPanel.classList.add('is-still');
    bandPanel.innerHTML = gamePanelHtml(bandGame, all);
  }

  function renderTcgs(all) {
    tcgsBody.innerHTML = tcgsBodyHtml(tcgsGame, all);
  }

  function openBand(i) {
    // già aperto su questo gioco: non si ridisegna
    if (bandGame === i && bandPanel.classList.contains('is-open')) return;
    var prev = openPanel();
    ghostOf(prev);
    closeTcgs();
    closeExtras();
    bandGame = i;
    cells.forEach(function (cell, k) {
      cell.setAttribute('aria-expanded', String(k === i));
    });
    bandPanel.classList.toggle('is-still', !!prev);
    renderBand(false);
    bandPanel.classList.add('is-open');
    if (!loaded[games[i].h]) {
      load(i).then(
        function () {
          if (bandGame === i && bandPanel.classList.contains('is-open')) renderBand(false);
        },
        function () {
          if (bandGame === i && bandPanel.classList.contains('is-open')) renderBand(false);
        }
      );
    }
  }

  function closeBand() {
    clearTimeout(bandTimer);
    if (!bandPanel) return;
    bandPanel.classList.remove('is-open');
    cells.forEach(function (cell) {
      cell.setAttribute('aria-expanded', 'false');
    });
    bandGame = -1;
  }

  function selectGame(i, focus) {
    tcgsGame = i;
    railItems.forEach(function (item, k) {
      item.setAttribute('aria-selected', String(k === i));
      item.setAttribute('tabindex', k === i ? '0' : '-1');
    });
    if (focus) railItems[i].focus();
    renderTcgs(false);
    if (!loaded[games[i].h]) {
      load(i).then(
        function () {
          if (tcgsGame === i && tcgsPanel.classList.contains('is-open')) renderTcgs(false);
        },
        function () {
          if (tcgsGame === i && tcgsPanel.classList.contains('is-open')) renderTcgs(false);
        }
      );
    }
  }

  function openTcgs(focusRail) {
    // già aperto: non si ridisegna (tornando sulla voce dal pannello non deve lampeggiare)
    if (tcgsPanel.classList.contains('is-open')) {
      if (focusRail && railItems[tcgsGame]) railItems[tcgsGame].focus();
      return;
    }
    var prev = openPanel();
    ghostOf(prev);
    closeBand();
    closeExtras();
    if (details) details.removeAttribute('open');
    tcgsPanel.classList.toggle('is-still', !!prev);
    tcgsPanel.classList.add('is-open');
    if (summary) summary.setAttribute('aria-expanded', 'true');
    selectGame(tcgsGame, focusRail);
  }

  function closeTcgs() {
    clearTimeout(tcgsTimer);
    if (!tcgsPanel) return;
    tcgsPanel.classList.remove('is-open');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function closeAll() {
    closeBand();
    closeTcgs();
    closeExtras();
  }

  /* banda: passando su un logo */
  cells.forEach(function (cell, i) {
    cell.addEventListener('mouseenter', function () {
      if (!active || !hover.matches) return;
      // dati e copertine partono subito, prima che il pannello si apra (se non sono già pre-caricati)
      load(i).then(
        function () {
          warm(i);
        },
        function () {}
      );
      clearTimeout(bandTimer);
      bandTimer = setTimeout(function () {
        openBand(i);
      }, 110);
    });
    cell.addEventListener('mouseleave', function () {
      if (!active || !hover.matches) return;
      clearTimeout(bandTimer);
      bandTimer = setTimeout(closeBand, 180);
    });
    // da tastiera: freccia giù apre il pannello e porta dentro
    cell.addEventListener('keydown', function (event) {
      if (!active || event.key !== 'ArrowDown') return;
      event.preventDefault();
      openBand(i);
      var first = bandPanel.querySelector('a, button');
      if (first) first.focus();
    });
  });

  if (bandPanel) {
    bandPanel.addEventListener('mouseenter', function () {
      clearTimeout(bandTimer);
    });
    bandPanel.addEventListener('mouseleave', function () {
      clearTimeout(bandTimer);
      bandTimer = setTimeout(closeBand, 180);
    });
    bandPanel.addEventListener('click', function (event) {
      var button = event.target.closest('[data-aycp-more]');
      if (!button) return;
      event.preventDefault();
      renderBand(true);
    });
  }

  /* TCGs: passando o cliccando sulla voce del menu */
  if (summary && tcgsPanel && games.length) {
    summary.addEventListener('mouseenter', function () {
      if (!active || !hover.matches) return;
      load(tcgsGame).catch(function () {});
      holdOpen();
      tcgsTimer = setTimeout(function () {
        openTcgs(false);
      }, 110);
    });
    summary.addEventListener('mouseleave', function () {
      // sugli schermi touch il "mouse" simulato lascia la voce subito dopo il tocco: lì si chiude toccando fuori
      if (!active || !hover.matches) return;
      clearTimeout(tcgsTimer);
      tcgsTimer = setTimeout(closeTcgs, 260);
      releaseOpen(tcgsPanel);
    });
    summary.addEventListener('click', function (event) {
      if (!active) return;
      event.preventDefault();
      clearTimeout(tcgsTimer);
      if (tcgsPanel.classList.contains('is-open') && event.detail !== 0 && hover.matches) return;
      if (tcgsPanel.classList.contains('is-open')) {
        closeTcgs();
      } else {
        openTcgs(event.detail === 0);
      }
    });
    tcgsPanel.addEventListener('mouseenter', function () {
      clearTimeout(tcgsTimer);
    });
    tcgsPanel.addEventListener('mouseleave', function () {
      if (!hover.matches) return;
      clearTimeout(tcgsTimer);
      tcgsTimer = setTimeout(closeTcgs, 260);
    });
    tcgsPanel.addEventListener('click', function (event) {
      var button = event.target.closest('[data-aycp-more]');
      if (!button) return;
      event.preventDefault();
      renderTcgs(true);
    });

    railItems.forEach(function (item, i) {
      item.addEventListener('mouseenter', function () {
        if (hover.matches && tcgsGame !== i) selectGame(i, false);
      });
      item.addEventListener('focus', function () {
        if (tcgsGame !== i) selectGame(i, false);
      });
      // con il mouse il gioco è già selezionato passandoci sopra: il clic apre la sua collezione;
      // sugli schermi touch il primo tocco lo seleziona (e mostra il pannello), il secondo apre la collezione
      item.addEventListener('pointerdown', function () {
        railDown = tcgsGame === i ? i : -1;
      });
      item.addEventListener('click', function () {
        if (hover.matches || railDown === i) {
          window.location.href = games[i].u;
        } else {
          selectGame(i, false);
        }
        railDown = -1;
      });
      item.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          window.location.href = games[i].u;
        } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          var next = (i + (event.key === 'ArrowDown' ? 1 : -1) + railItems.length) % railItems.length;
          selectGame(next, true);
        }
      });
    });
  }

  /* Esc chiude; un tocco fuori chiude */
  root.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    extras.forEach(function (x) {
      if (!x.panel.classList.contains('is-open')) return;
      var inside = x.panel.contains(event.target);
      closeExtra(x);
      if (inside) x.summary.focus();
    });
    var fromTcgs = tcgsPanel && tcgsPanel.contains(event.target);
    var cell = bandGame >= 0 ? cells[bandGame] : null;
    if (!(tcgsPanel && tcgsPanel.classList.contains('is-open')) && !(bandPanel && bandPanel.classList.contains('is-open'))) return;
    closeAll();
    if (fromTcgs && summary) summary.focus();
    else if (cell) cell.focus();
  });
  // conta come "fuori" anche un clic sulle fasce vuote ai lati del riquadro bianco (fanno parte del pannello,
  // quindi il clic non arriva alla pagina sotto)
  document.addEventListener('click', function (event) {
    if (!active) return;
    var t = event.target;
    // un pulsante che il pannello ha appena ridisegnato ("Mostra tutti i set"): il clic era dentro
    if (!t.isConnected) return;
    if (t.closest && t.closest('.aycp-mg__panel-in')) return;
    if (summary && summary.contains(t)) return;
    var onExtra = extras.some(function (x) {
      return x.summary.contains(t);
    });
    if (onExtra) return;
    closeAll();
  });

  /* ---------- pre-caricamento dopo il caricamento della pagina ---------- */
  var preloadStarted = false;

  function preloadAll() {
    if (!active || !hover.matches) return;
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
    var k = 0;
    // un gioco alla volta, nell'ordine della banda: i dati (dalla memoria della visita se ci sono) e poi le immagini
    (function next() {
      if (k >= games.length || !active) return;
      var i = k++;
      load(i)
        .then(
          function () {
            warm(i);
          },
          function () {}
        )
        .then(next);
    })();
  }

  function schedulePreload() {
    if (preloadStarted || !games.length) return;
    preloadStarted = true;
    var go = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(preloadAll, { timeout: 3000 });
      else setTimeout(preloadAll, 1000);
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  /* ---------- scorrendo: testata compatta che scende con un rimbalzo ---------- */
  var sentinel = null;
  var observer = null;
  var resizer = null;
  var compactOn = false;

  function setVars() {
    var head = wrap.querySelector('.header');
    var search = root.querySelector('.aycp-mg__search');
    section.style.setProperty('--aycp-top', (head ? head.offsetHeight : 0) + (search ? search.offsetHeight : 0) + 'px');
    if (compactOn) section.style.setProperty('--aycp-ch', wrap.offsetHeight + 'px');
  }

  function place() {
    if (!sentinel || compactOn) return;
    sentinel.style.top = section.getBoundingClientRect().bottom + window.scrollY + 'px';
  }

  function compact(on) {
    if (on === compactOn) return;
    closeAll();
    compactOn = on;
    if (on) {
      section.style.height = section.offsetHeight + 'px';
      wrap.classList.add('aycp-mg-c');
      section.classList.add('aycp-mg-c-on');
    } else {
      wrap.classList.remove('aycp-mg-c');
      section.classList.remove('aycp-mg-c-on');
      section.style.height = '';
    }
    setVars();
  }

  function onResize() {
    place();
    setVars();
  }

  function activate() {
    if (active) return;
    active = true;
    html.classList.add('aycp-mg-on');
    if (details) details.classList.add('aycp-mg-tcgs');
    extras.forEach(function (x) {
      if (x.details) x.details.classList.add('aycp-mg-x');
    });
    sentinel = document.createElement('div');
    sentinel.className = 'aycp-mg-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    // il tema nasconde i div vuoti: qui serve visibile per chi osserva lo scorrimento
    sentinel.style.cssText = 'position:absolute;left:0;width:1px;height:1px;pointer-events:none;visibility:hidden;display:block!important';
    document.body.appendChild(sentinel);
    place();
    setVars();
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        var e = entries[0];
        compact(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      observer.observe(sentinel);
    }
    if ('ResizeObserver' in window) {
      resizer = new ResizeObserver(function () {
        if (!compactOn) onResize();
      });
      resizer.observe(section);
    }
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('load', onResize);
    schedulePreload();
  }

  function deactivate() {
    if (!active) return;
    compact(false);
    closeAll();
    active = false;
    html.classList.remove('aycp-mg-on');
    if (details) details.classList.remove('aycp-mg-tcgs');
    extras.forEach(function (x) {
      if (x.details) x.details.classList.remove('aycp-mg-x');
    });
    if (observer) observer.disconnect();
    if (resizer) resizer.disconnect();
    if (sentinel) sentinel.remove();
    observer = resizer = sentinel = null;
    window.removeEventListener('resize', onResize);
    window.removeEventListener('load', onResize);
    section.style.removeProperty('--aycp-top');
    section.style.removeProperty('--aycp-ch');
  }

  function update() {
    if (desktop.matches) activate();
    else deactivate();
  }

  if (desktop.addEventListener) desktop.addEventListener('change', update);
  else if (desktop.addListener) desktop.addListener(update);
  update();

})();
